import React from "react";
import NftActivity from "./NftComponents/NftActivity";
import NftDescription from "./NftComponents/NftDescription";
import NftHeading from "./NftComponents/NftHeading";
import NftImage from "./NftComponents/NftImage";
import NftMore from "./NftComponents/NftMore";
import NftOffers from "./NftComponents/NftOffers";
import NftPrice from "./NftComponents/NftPrice";
import NftProperties from "./NftComponents/NftProperties";
const NftCollection = () => {
    return (
        <>
            <div className="_nft_wrapper">
                <div className="_nft_wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <NftImage/>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div className="_nft_content_wrap">
                                    <NftHeading/>
                                    <NftPrice/>
                                    <NftProperties/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="_nft_des_wrap">
                <div className="container">
                    <NftDescription collection={true}/>
                </div>

            </div>
            <NftOffers collection={true}/>
            <NftActivity/>
            <NftMore/>
        </>
    )
}
export default NftCollection;